/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Snippet_MarkdownInputs */

const en_directory_submit_badge_snippet_markdown = /** @type {(inputs: Directory_Submit_Badge_Snippet_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

const zh_directory_submit_badge_snippet_markdown = /** @type {(inputs: Directory_Submit_Badge_Snippet_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown`)
};

/**
* | output |
* | --- |
* | "Markdown" |
*
* @param {Directory_Submit_Badge_Snippet_MarkdownInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_snippet_markdown = /** @type {((inputs?: Directory_Submit_Badge_Snippet_MarkdownInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Snippet_MarkdownInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_snippet_markdown(inputs)
	return zh_directory_submit_badge_snippet_markdown(inputs)
});
export { directory_submit_badge_snippet_markdown as "directory.submit.badge_snippet_markdown" }